import { formatOrderDualCurrency } from '../../utils/formatters';

/**
 * Renders order money as: 37.04 $ (555,600 ل.س) — LTR for mixed scripts in RTL layout.
 */
const DualCurrencyAmount = ({ amountSyp, locale = 'en', className = '', style = {} }) => (
  <span
    dir="ltr"
    className={`dual-currency-amount ${className}`.trim()}
    style={{ whiteSpace: 'nowrap', display: 'inline-block', unicodeBidi: 'isolate', ...style }}
  >
    {formatOrderDualCurrency(amountSyp, locale)}
  </span>
);

export default DualCurrencyAmount;
